import helpers from '../helpers.js';
var parallaxObserver = {
    init: function () {
        const parallaxContainers = document.querySelectorAll(".parallax");
        var parallaxIntersectionOptions = {
            threshold: [0]
        }
        function parallaxIntersection(entries) {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    entry.target.classList.add("active");
                    window.addEventListener("scroll", animateParallax, true);
                } else {
                    entry.target.classList.remove("active");
                    window.removeEventListener("scroll", animateParallax, true);
                }
            });
        }
        const observer = new IntersectionObserver(parallaxIntersection, parallaxIntersectionOptions);

        parallaxContainers.forEach(el => observer.observe(el));
        const wdwHeight = window.innerHeight;
        
        function animateParallax() {
            let container = document.querySelector(".parallax.active");
            let parallaxBg = container.querySelector(".parallax__bg");
            let scrollPercent = 100*(helpers.getOffset(container).top - container.offsetHeight - (window.scrollY + (wdwHeight- container.offsetHeight)))/(wdwHeight+container.offsetHeight)/2;

            if(scrollPercent < -20)
                scrollPercent = -20;
            else if(scrollPercent > 0)
                scrollPercent = 0;
            
            parallaxBg.style.transform = "translateY(" + scrollPercent + "%)";
        }
    }
}

export default parallaxObserver;